import { useState } from "react";

export interface NumberInputProps {
    val: number;
    placeHolder: string;
    onChange: (val: number) => void;
    maxVal?: number;
    minVal?: number;
    name?: string;
    invalid?: boolean;
}

export const NumberInput: React.FC<NumberInputProps> = (props) => {
    return (
        <input
              type="number"
              placeholder={props.placeHolder}
              value={props.val}
              name={props.name ? props.name : ""}
              max={props.maxVal}
              min={props.minVal}
              onChange={(e) => props.onChange(Number(e.target.value))}
              className={`${props.invalid ? "border-red-500 border-[1px]" : ""} w-full rounded-xl shadow-main outline-none focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2`}
        />
    )
}